import { render } from "./AnalyticsScopeBar.vue?vue&type=template&id=53b60f48"
import script from "./AnalyticsScopeBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsScopeBar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Analytics/AnalyticsScopeBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53b60f48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53b60f48', __exports__)) {
    api.reload('53b60f48', __exports__)
  }
  
  module.hot.accept("./AnalyticsScopeBar.vue?vue&type=template&id=53b60f48", () => {
    api.rerender('53b60f48', render)
  })

}


export default __exports__